import { useGetMicrostoreColumnsPaginatedQuery, type MicrostoreColumnsFilterInput } from 'data/__generated__';

import { DataTable } from 'components/DataTable';

import { templateColumnsListColumns, type TemplateColumnRow } from '../constants/templateColumnsListColumns';

export const MicrostoreColumnTemplateColumnsList = ({
    microstoreColumnTemplateName,
}: {
    microstoreColumnTemplateName: string;
}) => {
    const filters: MicrostoreColumnsFilterInput = { microstoreColumnTemplateName };

    const { data, loading, error } = useGetMicrostoreColumnsPaginatedQuery({
        variables: { filters },
    });

    if (error) {
        throw new Error('Une erreur est survenue lors de la récupération des colonnes');
    }

    const microstoreColumns = data?.microstoreColumnsFilter.microstoreColumns ?? [];

    return (
        <DataTable<TemplateColumnRow>
            columns={templateColumnsListColumns}
            data={microstoreColumns}
            filterMode="client"
            getRowId={(row) => row._id}
            getRowLink={(row) => `/microstore-column/${row._id}`}
            isLoading={loading}
            disableColumnVisibility
            disableUrlSync
            autoFocusSearch={false}
        />
    );
};
